// extracted by mini-css-extract-plugin
export default {"banner":"Home_banner__GTSzg","content":"Home_content__1Ktqz","subtitle":"Home_subtitle__Xlgxy","background":"Home_background__6EwEP"};